import { Resource } from './resource';

export class JobDescription extends Resource {
  name: String;
  description: String;
  value: String;
  label: String;
  previousFileUrl:String;
  jobCategory:string;
  technology:string;
  specialAttribute:String;
}